import firebase from "firebase/app";
import "firebase/messaging";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyD4TEiJICUyPwR2rnPGXPNqNsPXvQIG7eg",
    authDomain: "thb-telehealth-web.firebaseapp.com",
    databaseURL: 'thb-telehealth-web.firebaseio.com',
    projectId: "thb-telehealth-web",
    storageBucket: "thb-telehealth-web.appspot.com",
    messagingSenderId: "653788661984",
    appId: "1:653788661984:web:4acc0ce3bd4b687ce22885",
    measurementId: 'G-measurement-id',
};

firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging();

const { REACT_APP_VAPID_KEY } = process.env;
const publicKey = REACT_APP_VAPID_KEY;

export const getFCMToken = async (setTokenFound) => {
  let currentToken = "";

  try {
    currentToken = await messaging.getToken({ vapidKey: publicKey });
    if (currentToken) {
      setTokenFound(true);
    } else {
      setTokenFound(false);
    }
  } catch (error) {
    console.log("An error occurred while retrieving token. ", error);
  }

  return currentToken;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });